import { FREE_EMAIL_DOMAINS } from '../constants'

const SECOND_LEVEL_SUFFIXES = ['CO', 'COM', 'NET', 'ORG', 'NE', 'OR', 'AC', 'GOV', 'EDU']

// Provider label of the registrable domain: gmail.com, yahoo.co.uk, uol.com.br -> GMAIL, YAHOO, UOL
const getEmailProvider = (email = '') => {
  const labels = (email.trim().split('@')[1] || '').toUpperCase().split('.').filter(Boolean)
  if (labels.length < 2) return null

  const tld = labels.pop()
  if (tld.length === 2 && labels.length > 1 && SECOND_LEVEL_SUFFIXES.includes(labels[labels.length - 1])) {
    labels.pop()
  }
  return labels[labels.length - 1]
}

export const isFreeEmailDomain = (email) => FREE_EMAIL_DOMAINS.includes(getEmailProvider(email))
